import {Component, OnInit, Input, ChangeDetectorRef} from '@angular/core';
import { Log } from 'src/app/util/log';

@Component({
  selector: 'app-loading-screen',
  templateUrl: './loading-screen.component.html',
  styleUrls: ['./loading-screen.component.css']
})
export class LoadingScreenComponent implements OnInit {

  @Input() loading: boolean = true;
  @Input() showtext: boolean = false;
  error = false;
  successAnimation = false;

  constructor(private cdRef:ChangeDetectorRef) {
  }

  ngOnInit() {
    
  }

  ngAfterViewInit() {
    if (this.loading) {
      this.showLoading();
    }
  }

  public showSuccess(): void {
    
    Log.debug("showSuccess");
    
    this.successAnimation = true;
    this.cdRef.detectChanges();

    setTimeout(function () {
      this.successAnimation = false;
    }, 2000);
  }

  public showLoading(): void {
    Log.debug("showLoading");
    this.loading = true;
    this.cdRef.detectChanges();
  }

  public hideLoading(): void {
    Log.debug("hideLoading");
    this.loading = false;
    this.cdRef.detectChanges();
  }

  public showError(): void {
    this.error = true;
    this.cdRef.detectChanges();
  }

  public hideError(): void {
    this.error = false;
    this.cdRef.detectChanges();
  }

  private reloadPage() {
    window.location.reload();
  }
}
